import { render, staticRenderFns } from "./UnitPayment.vue?vue&type=template&id=a13fc884&scoped=true&"
import script from "./UnitPayment.vue?vue&type=script&lang=js&"
export * from "./UnitPayment.vue?vue&type=script&lang=js&"
import style0 from "./UnitPayment.vue?vue&type=style&index=0&id=a13fc884&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13fc884",
  null
  
)

export default component.exports